import IconHelp from "@/assets/icons/icon-help.svg";
import { ConfirmDialog } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/auth-context";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { InquiryCardsSection } from "./components/inquiry-cards-section";
import { ProfileEditDialog } from "./components/profile-edit-dialog";
import { ProfileSection } from "./components/profile-section";
import { ProjectCardsSection } from "./components/project-cards-section";

export default function MyPage() {
  const navigate = useNavigate();
  const { user, isLoading, logout } = useAuth();
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [hasInquiries, setHasInquiries] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [loadingInquiries, setLoadingInquiries] = useState(true);

  const isPageLoading = isLoading || loadingProjects || loadingInquiries;

  if (!user && !isLoading) return null;

  return (
    <>
      {isPageLoading && (
        <div className="flex items-center justify-center py-20 h-[60vh] w-full">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-black/10 border-t-[#FF3B00]" />
        </div>
      )}

      <div
        className="flex flex-col gap-4 lg:gap-6 px-4 py-6 lg:px-[160px] lg:py-10 max-w-[1440px] mx-auto"
        style={{ display: isPageLoading ? "none" : "flex" }}
      >
        <div className="flex items-center gap-4">
          {/* <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="w-10 h-10 lg:w-12 lg:h-12 rounded-full bg-black/[0.04] hover:bg-black/[0.08] transition-colors"
          >
               <img src={icArrowLeft} alt="Back" />
          </Button> */}
          <h1 className="text-xl font-bold leading-[24px] lg:leading-[28px] tracking-[-0.018em] lg:tracking-[-0.02em] text-[#202020]">
            My page
          </h1>
        </div>

        <ProfileSection
          onEditClick={() => setShowEditDialog(true)}
          onLogoutClick={() => setShowLogoutDialog(true)}
        />
        {/* Pc */}
        <div className="hidden lg:flex lg:flex-col lg:gap-6">
          <ProjectCardsSection onLoadComplete={() => setLoadingProjects(false)} />
          {/* <AgentCardsSection /> */}
          <InquiryCardsSection
            onDataLoad={(hasData) => {
              setHasInquiries(hasData);
            }}
            onLoadComplete={() => setLoadingInquiries(false)}
          />
        </div>
        {/* Mobile */}

        <div className="lg:hidden mt-2">
          <Tabs defaultValue="projects" className="w-full">
            <TabsList className="w-full flex bg-transparent p-0 rounded-none border-b border-black/[0.09] h-12 justify-start gap-6">
              <TabsTrigger
                value="projects"
                className="h-full rounded-none data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-[#000000] text-[#B0B0B0] text-base font-bold px-0"
              >
                내 프로젝트
              </TabsTrigger>

              {hasInquiries && (
                <TabsTrigger
                  value="inquiries"
                  className="h-full rounded-none data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-[#000000] text-[#B0B0B0] text-base font-bold px-0"
                >
                  문의 이력
                </TabsTrigger>
              )}
            </TabsList>
            <TabsContent value="projects" className="pt-4 mt-0 outline-none">
              <ProjectCardsSection onLoadComplete={() => setLoadingProjects(false)} />
            </TabsContent>
            {/* <TabsContent value="agents" className="pt-4 mt-0 outline-none">
            <AgentCardsSection />
          </TabsContent> */}
            {hasInquiries && (
              <TabsContent value="inquiries" className="pt-4 mt-0 outline-none">
                <InquiryCardsSection
                  onDataLoad={(hasData) => {
                    setHasInquiries(hasData);
                  }}
                  onLoadComplete={() => setLoadingInquiries(false)}
                />
              </TabsContent>
            )}
          </Tabs>
        </div>

        <ProfileEditDialog open={showEditDialog} onOpenChange={setShowEditDialog} />

        <ConfirmDialog
          open={showLogoutDialog}
          onOpenChange={setShowLogoutDialog}
          icon={<img src={IconHelp} alt="Icon Alert Circle" />}
          iconVariant="neutral"
          title="로그아웃를 하시겠습니까?"
          description="현재 계정에서 로그아웃됩니다"
          primaryAction={{
            label: "네",
            onClick: () => {
              setShowLogoutDialog(false);
              logout();
            },
          }}
          secondaryAction={{
            label: "아니요",
            onClick: () => setShowLogoutDialog(false),
          }}
        />
      </div>
    </>
  );
}
